import DeliveryAddressResourceModel from '../../generated/types/model/resource/DeliveryAddressResourceModel';

export default class DeliveryAddressResourceViewModel extends DeliveryAddressResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
